// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1-Y8t","requiredAsterisk":"Info_requiredAsterisk__10m_0"};